import { $_DKD, $_WC } from '@/confs/common.const.js';
import commonApi from "@/apis/common.api.js";
import gripUtil from "@/libs/grip.util";

export default {
    state: {
    	realtimeCityList: [],
    	realtimeCitySelectedList: [],
    	realtimeCityCalMap: {},
    	
        realtimeCityMap: {},
    	
    	cultureEvent: [],
    },
    getters: {
        getRealtimeCityList(state) {
            return state.realtimeCityList;
        },
        getRealtimeCitySelectedList(state) {
            return state.realtimeCitySelectedList;
        },
        getRealtimeCityCalMap(state) {
            return state.realtimeCityCalMap;
        },
        getRealtimeCityMap(state) {
            return state.realtimeCityMap;
        },
        getCultureEvent(state) {
            return state.cultureEvent;
        },
        
    },
    mutations: {
    	SET_REALTIME_CITY_LIST(state, realtimeCityList) {
            state.realtimeCityList = realtimeCityList;
        },
        SET_REALTIME_CITY_SELECTED_LIST(state, realtimeCitySelectedList) {
            state.realtimeCitySelectedList = realtimeCitySelectedList;
        },
        SET_REALTIME_CITY_CAL_MAP(state, realtimeCityCalMap) {
            state.realtimeCityCalMap = realtimeCityCalMap;
        },
        SET_REALTIME_CITY_MAP(state, realtimeCityMap) {
            state.realtimeCityMap = realtimeCityMap;
        },
        SET_CULTURE_EVENT(state, cultureEvent) {
            state.cultureEvent = cultureEvent;
        },
        
    },
    actions: {
        FETCH_REALTIME_CITY_LIST({commit}) {
            let q = '';
            q += 'orderBy=basdtVal::desc&searchLimit=50';
            return commonApi.fetchRepoDataList($_DKD.REALTIME_CITY, q)
                .then((res) => {
                    let tmpMap = gripUtil.toMap(res.data.data, 'val1');
                    let list = [];
                    for(let key in tmpMap) {
                        tmpMap[key] = tmpMap[key].sort((pre, cur) => {
                            return Number(cur.basdtVal) - Number(pre.basdtVal);
                        });
                        list.push(tmpMap[key][0]);
                    }
                    let map = {};
                    list.forEach(function(d){
                        if(typeof map[d.val1] == 'undefined') {
                            map[d.val1] = {};
                        }
                        map[d.val1] = d;
                    });
                    
                    let realtimeCityMap = gripUtil.toDict(list, 'val1');

                    commit('SET_REALTIME_CITY_CAL_MAP', map);
                    commit('SET_REALTIME_CITY_LIST', res.data.data);
                    commit('SET_REALTIME_CITY_MAP', realtimeCityMap);
                });
        },
        // this.$store.dispatch("FETCH_COVID_CONFIRM_LIST", 'val19=N&val7=' + encodeURIComponent('강남구') + '&orderBy=basdt_val%20desc');
        FETCH_REALTIME_CITY_SELECTED_LIST({commit} , q) {
            return commonApi.fetchRepoDataList($_DKD.REALTIME_CITY, q)
                .then(res => {
                    let list = res.data.data.sort((pre, cur) => {
                        return Number(pre.basdtVal) - Number(cur.basdtVal);
                    });

                    commit('SET_REALTIME_CITY_SELECTED_LIST', list);
                });
        },
        
        FETCH_CULTURE_EVENT({commit} , q) {
            return commonApi.fetchRepoDataList($_DKD.CULTURAL_EVENT, q)
                .then(res => {
                    let list = res.data.data;
                    let reg = $_WC.eventReg;
                    list.forEach((d) => {
                        if(reg.test(d.val3)) {
                            d.val3 = d.val3.replace(reg, '');
                        }
                    });
                    let map = gripUtil.toMap(list, 'val3');
                    // console.log('map', map);
                    commit('SET_CULTURE_EVENT', map);
                });
        },
    }
}
